import { render, staticRenderFns } from "./CustomerProposals.vue?vue&type=template&id=21fc02bb&scoped=true&"
import script from "./CustomerProposals.vue?vue&type=script&lang=js&"
export * from "./CustomerProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc02bb",
  null
  
)

export default component.exports